import {Component, Directive, Input, NgModule} from '@angular/core';

@Directive({
  selector: 'sd-label',
  standalone: true,
  host: {class: 'sd-field__label mb-1 block text-xs font-medium text-[var(--m365-text-secondary,#6b6b70)]'},
})
export class SdLabel {}

@Directive({
  selector: 'sd-hint',
  standalone: true,
  host: {class: 'sd-field__hint mt-1 block text-xs text-[var(--m365-text-secondary,#6b6b70)]'},
})
export class SdHint {}

@Directive({
  selector: 'sd-error',
  standalone: true,
  host: {class: 'sd-field__error mt-1 block text-xs text-red-600'},
})
export class SdError {}

@Directive({
  selector: '[sdPrefix], [sdIconPrefix]',
  standalone: true,
  host: {class: 'sd-field__prefix mr-2 text-[var(--m365-text-secondary,#6b6b70)]'},
})
export class SdPrefix {}

@Directive({
  selector: '[sdSuffix], [sdIconSuffix]',
  standalone: true,
  host: {class: 'sd-field__suffix ml-2 text-[var(--m365-text-secondary,#6b6b70)]'},
})
export class SdSuffix {}

@Component({
  selector: 'sd-form-field',
  standalone: true,
  template: `
    <div class="sd-field flex w-full flex-col"
         [class.sd-field--outline]="appearance !== 'fill'"
         [class.sd-field--fill]="appearance === 'fill'">
      <ng-content select="sd-label"></ng-content>
      <div class="sd-field__control flex min-h-10 items-center rounded-[10px] border border-[var(--m365-border-rest,#ececf0)] bg-white px-3 py-1.5 transition-colors focus-within:border-[var(--m365-text-primary,#111)] focus-within:shadow-[0_0_0_3px_rgba(17,17,17,0.06)]">
        <ng-content select="[sdPrefix], [sdIconPrefix]"></ng-content>
        <div class="min-w-0 flex-1">
          <ng-content></ng-content>
        </div>
        <ng-content select="[sdSuffix], [sdIconSuffix], sd-datepicker-toggle"></ng-content>
      </div>
      <ng-content select="sd-hint, sd-error"></ng-content>
    </div>
  `,
  host: {class: 'sd-form-field block w-full'},
})
export class SdFormField {
  @Input() appearance: 'fill' | 'outline' | string = 'fill';
  @Input() color: string | undefined;
  @Input() subscriptSizing: 'fixed' | 'dynamic' | string | undefined;
  @Input() hideRequiredMarker = false;
  @Input() floatLabel: 'always' | 'auto' | string | undefined;
  @Input() hintLabel: string | undefined;
}

@NgModule({
  imports: [SdFormField, SdLabel, SdHint, SdError, SdPrefix, SdSuffix],
  exports: [SdFormField, SdLabel, SdHint, SdError, SdPrefix, SdSuffix],
})
export class SdFormFieldModule {}
